import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/utilities/Button';

export default function NotFoundPage() {
  return (
    <div className="h-[calc(100vh-200px)] w-full flex flex-col items-center justify-center">
      <h1 className="font-extrabold text-4xl">Not found</h1>
      <Link to="/" className="mt-4">
        <Button label="Back to home" />
      </Link>
    </div>
  );
}
